import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { cartState, cartCountState, cartTotalState } from '../../atoms';
import { TextControl, SelectControl, CountryControl, BinaryControl } from '../InputControls';
import './style.css';
import CheckoutForm from './cart';

export default function CartPage() {
  //const [cart, setCart] = useRecoilState(cartState);
  const [items, setItems] = useState([]);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(true);
  const [country, setCountry] = useState('US');
  const cartCount = useRecoilValue(cartCountState);
  const [shipping, setShipping] = useState(5);
  const cartTotal = useRecoilValue(cartTotalState);
  const [message, setMessage] = useState('');
  const [checkingOut, setCheckingOut] = useState(false);

  const [cart, setCart] = useState({ "9798990416512": { "id": "9798990416512", "priceId": "price_1PTQPGFoScMjUSrmpXtAGO8I", "title": "The Frontier Index", "author": "Raymond Pettibon & Mike Topp", "image": "Frontier.png", "price": 14.99, "weight": 6, "count": 5 }, "9798990416529": { "id": "9798990416529", "title": "Grocery List", "author": "Bora Chung", "image": "GroceryList.png", "priceId": "price_1PTBM1FoScMjUSrmDaiSQ6l4", "price": 14.99, "count": 1 } });

  document.title = `Cart | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Checkout to complete your order.`);


  const calculateShipping = () => {
    let newShipping;
    if (country === 'US') {
      newShipping = 4.75 + (cartCount * .25);
    } else {
      newShipping = 9.75 + (cartCount * .25);
    }
    return newShipping;
  }

  useEffect(() => {
    setItems(Object.values(cart));
    let newShipping = calculateShipping();
    setShipping(newShipping)
  }, [cart, country]);

  const changeQuantity = (id, no) => {
    let newCart = { ...cart };
    let newItem = { ...cart[id] };
    newItem.count = newItem.count += no;
    newCart[id] = newItem;
    setCart(newCart);
  }

  const checkout = async () => {
    setMessage('');
    if (!email) {
      setMessage('Please enter a valid email');
      return;
    } else if (!country) {
      setMessage('Please select a country for shipping');
      return;
    }
    setCheckingOut(true);
  }

  return (
    <div className='pageContainer cartPage'>
      <div>
        <h1>Your Order</h1>
        {items.map((item) =>
          <div className='cartItem'>
            <div className='cartItemImage cartCell'>
              <div><img src={`../../${item.image}`} alt={`Cover for ${item.title}`} /></div>
            </div>
            <div className='cartDetails'>
              <div className='cartCellContents cartCellDetailInfo'>
                <div className='cartItemTitle'>{item.title}</div>
                <div className='cartItemAuthor'>{item.author}</div>
              </div>
              <div className='cartCell'>
                <div className='cartCellContents'>
                  ${item.price}
                </div>
              </div>
              <div className='cartCell'>
                <div className='cartCellContents itemCountControls'>
                  <button className='cartIncrement' onClick={() => { changeQuantity(item.id, -1) }}><span>-</span></button>
                  <div className='cartItemCount'>
                    <div className='cartItemCountNo'>{item.count}</div>
                  </div>
                  <button className='cartIncrement' onClick={() => { changeQuantity(item.id, 1) }}><span>+</span></button>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className='cartItem shipping'>
          <div></div>
          <div>Shipping & Handling</div>
          <div>${shipping.toFixed(2)}</div>
          <div></div>
        </div>
        <div className='cartItem subtotal'>
          <div></div>
          <div>Subtotal</div>
          <div>${(cartTotal + shipping).toFixed(2)}</div>
          <div></div>
        </div>
        {items.length === 0 && <div>There is nothing in your cart</div>}
      </div>
      <div>
        <TextControl
          label='Your Email'
          value={email}
          change={setEmail}
        />
        <BinaryControl
          label='Please keep me updated on future publications and announcements'
          value={consent}
          change={setConsent}
          options={['Yes', 'No']}
        />
        <CountryControl
          value={country}
          change={setCountry}
          label='Shipping To'
        />
        {message && <div className='cartMessage'>{message}</div>}
        <button className='checkoutButton' onClick={checkout}>Checkout</button>
        {checkingOut && <CheckoutForm cart={cart} close={() => { setCheckingOut(false) }} />}
      </div>
    </div>
  )
}